module.exports = __webpack_public_path__ + "static/media/IMG-5.6eac019d.jpg";